/**
 * alipay模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const alipay = {
  getAlipayFormHtml (params) {
    return axios.get('/api/Alipay/GetAlipayFormHtml', { params })
  }
}

export default alipay
